<template>
  <div>
    <div class="reading-context" v-dompurify-html="content"></div>
    <a class="join-discord" href="//discord.gg/maddy">
      <font-awesome-icon class="icon" :icon="['fab', 'discord']" /> Join us on
      Discord!</a
    >
  </div>
</template>

<script>
export default {
  name: 'study-information',
  props: ['content'],
};
</script>

<style lang="scss" scoped>
.join-discord {
  display: inline-flex;
  align-items: center;
  color: color('discord');
  font-weight: 500;

  .icon {
    margin-right: 0.5rem;
  }
}
</style>
